import React, { useState, useEffect } from "react";
import SideInfo from "./SideInfo";
import icon from "../assets/icons/explore.svg";
import { useStoreState, useStoreActions } from "../store";

const MainPageComponent = () => {
  const [data, setData] = useState();

  const detailsCountry = useStoreState(s => s.detailsCountry);
  const sidebarOpen = useStoreState(s => s.sidebarOpen);
  const toggleSidebar = useStoreActions(s => s.toggleSidebar);

  useEffect(() => {
    if (detailsCountry && detailsCountry.ISOCode) {
      toggleSidebar(true);

      fetch(`/countryData/${detailsCountry.ISOCode.toLowerCase()}.json`)
        .then(response => response.json())
        .then(myJson => setData(myJson));
    }
  }, [detailsCountry?.ISOCode]);

  return (
    <section className="main">
      <h1 className="title">
        How well <br />
        do you know the world?
      </h1>
      <h5 className="helper">
        <img src={icon} alt="explore icon" className="helper__icon" />
        Grab and spin the globe to find more places, click on a point to
        explore.
      </h5>

      <SideInfo
        open={sidebarOpen}
        onClose={() => toggleSidebar(false)}
        country={detailsCountry}
        data={data}
      />
    </section>
  );
};

export default MainPageComponent;
